import { useState, useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { debounce } from "lodash"
import { getQuestionnaireTemplates } from "store/question"
import { DEFAULT_PAGE_SIZE, INITIAL_PAGE,DEBOUNCE_DELAY } from "../constants"
export const useTemplates = (searchText) => {
  const dispatch = useDispatch()
  const [pagination, setPagination] = useState({
    current: INITIAL_PAGE,
    pageSize: DEFAULT_PAGE_SIZE,
    total: 0
  })

  // Select data from Redux store
  const questionState = useSelector((state) => state.question.questionnaireTemplates || {})
  const loading = useSelector((state) => state.question.questionnaireTemplates.loading)
  const metadata = useSelector((state) => state.question.metadata || {})

  // Extract data from the response
  const templates = Array.isArray(questionState.data) ? questionState.data : []

  // Memoized debounced search function
  const debouncedSearch = useMemo(
    () =>
      debounce((term, pageSize) => {
        dispatch(getQuestionnaireTemplates(INITIAL_PAGE, pageSize, term))
      }, DEBOUNCE_DELAY),
    [dispatch]
  )

  // Handle search with debounce
  useEffect(() => {
    debouncedSearch(searchText, pagination.pageSize)
    return () => debouncedSearch.cancel()
  }, [searchText, pagination.pageSize, debouncedSearch])

  // Handle page change
  const handlePageChange = (page) => {
    dispatch(getQuestionnaireTemplates(page, pagination.pageSize, searchText))
  }

  // Handle page size change
  const handlePageSizeChange = (newPageSize) => {
    setPagination((prev) => ({
      ...prev,
      pageSize: newPageSize,
      current: INITIAL_PAGE
    }))
    dispatch(getQuestionnaireTemplates(INITIAL_PAGE, newPageSize, searchText))
  }

  return {
    templates,
    loading,
    metadata,
    pagination,
    handlePageChange,
    handlePageSizeChange
  }
}
